<style scoped lang="less">
    .context-menu > ul {
        /*padding: 0 10px 0 0;*/
    }

    .context-menu > ul > li {
        margin: 5px auto;
        height: 2em;
        line-height: 2em;
        text-indent: 0.5em;
        cursor: pointer;
        position: relative;
        /*padding-right: 1em;*/
        list-style: none;
        /*padding: 0 5px;*/
    }

    .context-menu > ul > li:hover {
        color: #f0f0f0;
    }
    .menu-text{
        display: inline-block;
        margin: 0 10px 0 0;
    }
</style>
<template>
    <div v-if="showMenu" class="context-menu" id="context_menu_outline" style="position: fixed;z-index: 99999;left: 50%;top: 50%;background-color: #fff;border: 1px solid #DDD;" v-bind:style="stylePosition">
        <ul>
            <li v-for="(item,index) of menu.menus" v-show="item.show" :key="index" @click="onMenuClick(index)">
                <Icon v-if="item.icon" :type="item.icon" class="menu-icon" style="width: 1.5em;"></Icon>
                <span class="menu-text" style="display: inline-block;font-size: 12px;">{{$t(item.text)}}</span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "context-menu",
        props: {
            menu: Object
        },
        watch: {
            'menu.show': function (newa, ola) {
                if (newa) this.$store.commit('showMenu');
            }
        },
        computed: {
            stylePosition () {

                let stl = {
                    top: this.menu.position.y - 1 + 'px'
                };
                if (window.innerWidth - this.menu.position.y < 150) {
                    stl.top = (this.menu.position.y - 150) +'px'
                }
                if ((window.innerWidth - this.menu.position.x) < 150) {
                    stl.left = this.menu.position.x - 149 + 'px';
                    stl.width = 150 + 'px';
                } else {
                    stl.left = this.menu.position.x + 1 + 'px';
                }
                return stl;
            },
            showMenu () {
                let show = this.$store.state.app.showContentMenu;
                this.menu.show = show;
                return show;
            }
        },

        methods: {
            onMenuClick(index) {
                this.$emit('onSelect', index);
                this.menu.show = false;
            },
            close() {
                this.menu.show = false;
            }
        },
        mounted() {

        },

    }
</script>
